import useCMS from "../../shared/composables/useCMS"

export default function useUtils () {

    const truncate = (value, limit = 30) => {
        if (value.length > limit) {
            value = value.substring(0, (limit - 3)) + '...';
        }

        return value;
    }

    const toCurrency = (value, decimalPlaces = 2) => {
        if(!value){return value;}
        return '$'+value.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const breakCharsToBr = (str = "") => {
        return str.replace(/(?:\r\n|\r|\n)/g, '<br>');
    }

    const printPage = () => {
        window.print();
    }

    const updateFeedback = (feedback, msg, statusOrClass) => {
        feedback.value.message = msg;
        if(isNaN(statusOrClass)){
            feedback.value.class = statusOrClass;
        } else {
            feedback.value.class = (statusOrClass == 200) ? 'alert-success' : 'alert-danger'
        }
    }

    //Remote calls should return 401 is _isLoggedIn() is false
    const authResponseCheck = (response) => {
        const { pageURLs } = useCMS();

        if(response.data.status == 401){
            window.location = '/'+pageURLs[93]+"?mode=campbellcloud";
        }
    }

    const axiosResult = (response) => {
        return {status:200,data:response};
    }

    const formatCurrency = (value,currency) => {
        /* In the future this can be used */
        //var formatter = new Intl.NumberFormat('en-US',{style:'currency',currency: currency});
        //return formatter.format(value);

        return value.toLocaleString() + ' ' + currency;
    }

    return {
        truncate,
        toCurrency,
        breakCharsToBr,
        printPage,
        updateFeedback,
        authResponseCheck,
        axiosResult,
        formatCurrency
    }
}
